var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronLeftEnd = function SvgChevronLeftEnd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13456 4.08137C4.81112 3.82261 4.33915 3.87505 4.08039 4.1985C3.82163 4.52195 3.87408 4.99391 4.19752 5.25267L7.53086 7.91934C7.80477 8.13847 8.19398 8.13847 8.4679 7.91934L11.8012 5.25267C12.1247 4.99391 12.1771 4.52195 11.9184 4.1985C11.6596 3.87505 11.1876 3.82261 10.8642 4.08137L7.99938 6.37322L5.13456 4.08137ZM5.13456 8.08137C4.81112 7.82261 4.33915 7.87505 4.08039 8.1985C3.82163 8.52194 3.87408 8.99391 4.19752 9.25267L7.53086 11.9193C7.80477 12.1385 8.19398 12.1385 8.4679 11.9193L11.8012 9.25267C12.1247 8.99391 12.1771 8.52194 11.9184 8.1985C11.6596 7.87505 11.1876 7.82261 10.8642 8.08137L7.99938 10.3732L5.13456 8.08137Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeftEnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-left-end.d07c3342a097a7df898547287cb72c68.svg";